<div class="section" *ngIf="hasContent || editModeSet">
  <div class="section__header">
    <h2 class="section__header-text">Sales</h2>
  </div>
  <div class="section__body">
    <div class="data-block data-block--shaded-labels">
      <div *ngIf="aircraftSalesTypesTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label">Aircraft Sales Types:
          <mat-icon (click)="openEditSalesDialog(['Sales::Types::'], null , 'Aircraft Sales Types')" *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list [items]="aircraftSalesTypesTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !aircraftSalesTypesTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
      <div *ngIf="aircraftTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label">Aircraft Manufacturers:
          <mat-icon (click)="openEditSalesDialog(['Sales::Aircraft::'], null , 'Aircraft Manufacturers')" *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list [items]="aircraftTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !aircraftTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
      <div *ngIf="avionicsTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label">Avionics:
          <mat-icon (click)="openEditSalesDialog(['Sales::Avionics::'], null , 'Avionics')" *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list [items]="avionicsTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !avionicsTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
